/* Сцена пустой выдачи — та же, что у прототипа (zeroHTML в bot-studio.js): карточка со свечением,
   веер из трёх призрачных плиток с тенью и лупой поверх, затем заголовок, пояснение и одно действие.
   Разметка .st-zero > .zs(.zf + .zt > i×3 + .zo) + b + p + .btn держится правилами bot-studio.css. */
import type { ReactNode } from 'react';
import { uiText } from '../../i18n';
import { StudioIcon } from './StudioIcon';

export interface StudioZeroAction {
  label: string;
  icon?: string;
  onClick(): void;
}
export function StudioZero({ title, text, action }: { title: string; text?: ReactNode; action?: StudioZeroAction }) {
  return (
    /* role у эталона нет: сцена живёт в своём держателе (.st-sre, .st-lbl), он и меняется */
    <div className="st-zero">
      <div className="zs" aria-hidden="true">
        <span className="zf" />
        <span className="zt">
          <i />
          <i />
          <i />
        </span>
        <span className="zo">
          <StudioIcon kind="search" />
        </span>
      </div>
      <b>{uiText(title)}</b>
      {!!text && <p>{text}</p>}
      {action && (
        <button type="button" className="btn" onClick={action.onClick}>
          <StudioIcon kind={action.icon ?? 'grid'} />
          {uiText(action.label)}
        </button>
      )}
    </div>
  );
}
